export default __webpack_public_path__ + "static/media/appimg.f54cdccf.svg";